import "./main.sass"
import workersUrl from "@opendaw/studio-core/workers-main.js?worker&url"
import workletsUrl from "@opendaw/studio-core/processors.js?url"
import offlineEngineUrl from "@opendaw/studio-core/offline-engine.js?worker&url"
import {boot} from "@/boot"
import {initializeColors} from "@opendaw/studio-enums"
import {Browser} from "@opendaw/lib-dom"
import {ClerkAuth} from "@/jerry/auth/ClerkAuth"
import {ClerkLoginPage} from "@/jerry/auth/ClerkLoginPage"
import {NoFeaturedPreacherBanner} from "@/jerry/banners/NoFeaturedPreacherBanner"
import {addIcons} from "ionicons"
import {defineCustomElement as defineIonIcon} from "ionicons/components/ion-icon.js"
import * as ionIcons from "ionicons/icons"

addIcons(Object.fromEntries(Object.entries(ionIcons)))
defineIonIcon()

if (Browser.isMobile()) {
    document.body.innerHTML = `<div style="display:flex;align-items:center;justify-content:center;height:100vh;padding:2em;text-align:center;font-family:system-ui;color:#ccc;background:#1a1a1a">
        <div><h1>openDAW</h1><p>openDAW requires a desktop browser.<br>Please visit on a computer.</p></div>
    </div>`
} else if (window.crossOriginIsolated) {
    // Initialize Clerk, show login if not signed in, then boot the DAW.
    // The DAW never boots unless Clerk confirms the user is authenticated.
    // Any failure in the auth flow locks the page — no fallback, no bypass.
    ;(async () => {
        try {
            const now = Date.now()
            initializeColors(document.documentElement)

            // 1. Initialize Clerk — if this fails (network down, CDN blocked, etc.)
            //    we fall into the catch block and the DAW never starts.
            await ClerkAuth.init()

            // 2. Double-check: if somehow init() succeeded but session is missing,
            //    show the login page and wait for a real sign-in.
            if (!ClerkAuth.isSignedIn()) {
                await ClerkLoginPage.show()
            }

            // 3. Final guard — only boot if we are genuinely signed in.
            //    This is the hard gate: boot() is never reachable without auth.
            if (!ClerkAuth.isSignedIn()) {
                throw new Error("Authentication required")
            }

            // 4. Boot the DAW — user is authenticated.
            await boot({workersUrl, workletsUrl, offlineEngineUrl})
            console.debug(`Booted in ${Math.ceil(Date.now() - now)}ms`)

            // 5. Start the no-featured-preacher banner watcher.
            NoFeaturedPreacherBanner.init()

        } catch (err) {
            // Auth failed or was bypassed — show a hard lock screen.
            // The DAW never loads from this state.
            console.error("[Sunday Triggers] Auth failed:", err)
            document.body.innerHTML = `
                <div style="display:flex;align-items:center;justify-content:center;
                            height:100vh;padding:2em;text-align:center;
                            font-family:system-ui;color:#ccc;background:#0d0d1a">
                    <div>
                        <div style="font-size:48px;margin-bottom:16px">🔒</div>
                        <h2 style="color:#e0e0f0;margin-bottom:8px">Authentication Required</h2>
                        <p style="color:#7070a0;margin-bottom:24px">
                            You must be signed in to access Sunday Triggers Studio.
                        </p>
                        <button onclick="window.location.reload()"
                            style="background:#7c3aed;color:white;border:none;
                                   padding:10px 24px;border-radius:6px;
                                   font-size:14px;cursor:pointer">
                            Try Again
                        </button>
                    </div>
                </div>`
        }
    })()
} else {
    alert("crossOriginIsolated must be enabled")
}